import React from 'react';
import {Header, Link} from '@amzn/awsui-components-react';

export default function Help() {
    return (
        <div className={'mainArea'}>
            <Header variant="h1">Help</Header>
            <Link
                href="https://w.amazon.com/bin/view/F3/F3_Grocery_Supply_Chain/Sales_And_Operations_Planning/Excelsior/FAQ#HFurthersupport"
                target={'_blank'}
                rel={'noopener noreferrer'}
                fontSize="heading-m"
            >
                Further Support
            </Link>
        </div>
    );
}
